import queryString from 'query-string';
import type {
	AvailableRule,
	Rule,
} from '@jira/project-settings__workflow-types/src/workflowTypes.types.tsx';

export const getLegacyEditorLink = (workflowName: string): string =>
	`/secure/admin/workflows/WorkflowDesigner.jspa?workflowMode=live&wfName=${encodeURIComponent(
		workflowName,
	)}`;

export const getLegacyEditorDraftLink = (workflowName: string): string =>
	`/secure/admin/workflows/WorkflowDesigner.jspa?${queryString.stringify({
		workflowMode: 'draft',
		wfName: workflowName,
	})}`;

export const getNewEditorLink = (workflowId: string): string =>
	`/jira/settings/issues/workflows/${workflowId}`;

export const findRuleDefinitionForConfiguredRule = (
	rule: Rule,
	availableRules: AvailableRule[],
): AvailableRule | undefined => {
	const ruleKey = rule.ruleKey;

	if (ruleKey.startsWith('connect')) {
		return availableRules.find(
			(definition) =>
				definition.variety === 'connect' &&
				definition.key === ruleKey &&
				definition.id === rule.config.appKey,
		);
	}

	if (ruleKey.startsWith('forge')) {
		return availableRules.find(
			(definition) =>
				definition.variety === 'forge' &&
				definition.key === ruleKey &&
				definition.id === rule.config.key,
		);
	}

	return availableRules.find((definition) => definition.key === ruleKey);
};
